const parsePageRange = (pageRange, totalPages) => {
  let startPage = 1;
  let endPage = totalPages;

  if (pageRange) {
    const range = pageRange.split("-");
    startPage = parseInt(range[0], 10);
    endPage = range[1] ? parseInt(range[1], 10) : startPage;

    if (isNaN(startPage) || isNaN(endPage) || startPage < 1 || endPage > totalPages) {
      console.error("Invalid page range!");
      return { startPage: 1, endPage: totalPages };
    }
  }

  return { startPage, endPage };
};

export const calculatePrice = (
  formData,
  totalPages,
  prices,
  wantBinding = false,
  bindingPrices = null,
  fileType = null
) => {
  if (!prices || totalPages <= 0) return 0;

  if (
    !formData?.colorType ||
    !formData?.paperType ||
    !formData?.paperSize ||
    !formData?.pagesPerSheet ||
    !formData?.copies
  ) {
    return 0;
  }

  let startPage = 1;
  let endPage = totalPages;

  if (formData.pageRange && formData.enableRange) {
    const range = formData.pageRange.split("-");
    startPage = parseInt(range[0], 10);
    endPage = range[1] ? parseInt(range[1], 10) : startPage;

    if (isNaN(startPage) || isNaN(endPage) || startPage < 1 || endPage > totalPages) {
      console.error("Invalid page range!");
      return 0;
    }
  }

  // Calculate actual pages to print based on pages per sheet
  const pagesInRange = endPage - startPage + 1;
  const pagesPerSheet = parseInt(formData.pagesPerSheet, 10) || 1;
  const physicalPagesToPrint = Math.ceil(pagesInRange / pagesPerSheet);

  const priceKey = `${formData.paperType}_${formData.paperSize}_${formData.pagesPerSheet}`;

  let pricePerPage = 0;
  if (prices[formData.colorType] && prices[formData.colorType][priceKey]) {
    pricePerPage = prices[formData.colorType][priceKey];
  } else {
    console.error("Price not found for:", formData.colorType, priceKey);
    return 0;
  }

  // Use physicalPagesToPrint instead of pagesInRange for base price calculation
  const basePrice = pricePerPage * formData.copies * physicalPagesToPrint;

  let bindingPrice = 0;
  if (wantBinding && bindingPrices) {
    // For binding, we still use the original page count (not reduced by pages per sheet)
    const pagesInDocument = formData.enableRange
      ? (() => {
          const { startPage, endPage } = parsePageRange(formData.pageRange, totalPages);
          return endPage - startPage + 1;
        })()
      : totalPages;

    bindingPrice =
      formData.copies *
      (pagesInDocument <= bindingPrices.minPages
        ? bindingPrices.fixedPrice
        : bindingPrices.fixedPrice +
          (pagesInDocument - bindingPrices.minPages) * bindingPrices.perPagePrice);
  }

  // Add extra 7 rupees if pages in range are more than 15, but only for non-image files
  // Note: We use the original page count (pagesInRange) for this check, not physical pages
  console.log("color type" , formData.colorType);
  
  // Add extra ₹7 if file is not an image, more than 10 pages, and colorType is NOT "color"
  const extraCharge =
    fileType &&
    !fileType.startsWith("image/") &&
    pagesInRange > 10 &&
    formData.colorType !== "Color"
      ? 7
      : 0;

  return basePrice + (wantBinding ? bindingPrice : 0) + extraCharge;
};

export const calculatePriceforppt = (
  formData,
  totalPages,
  prices,
  wantBinding = false,
  bindingPrices = null
) => {
  return calculatePrice(
    formData,
    totalPages,
    prices,
    wantBinding,
    bindingPrices,
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  );
};
